export default "__VITE_ASSET__9bb83155__"